import React from 'react';
import { Link } from 'react-router-dom';
import Title from '../Title';
import Button from '../Button';
import AboutCompany from '../../assets/about/homepage-about-company.jpg';
import { useTranslation } from 'react-i18next';

import '../../index.css';

const About = () => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col items-center p-6 md:p-12 gap-6 lg:gap-12'>
      <Title>
        <p className='flex flex-col justify-center items-center'>
          <span>{t('about.about_title_1')}</span>
          <span>{t('about.about_title_2')}</span>
        </p>
      </Title>
      <div className='flex flex-col lg:flex-row mx-auto gap-12 max-w-[1600px] w-full'>
        <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-12'>
          <div className='lg:w-1/2 lg:order-2'>
            <img
              src={AboutCompany}
              alt='AboutPic'
              loading='lazy'
              className='max-w-full max-h-full rounded object-contain'
            />
          </div>
          <div className='flex flex-col w-full lg:w-1/2 gap-6'>
            <div className='flex flex-col gap-6 text-lg lg:text-xl text-justify font-light text-primary-blue'>
              <p>{t('about.about_paragraph_1')}</p>
              <p>{t('about.about_paragraph_2')}</p>
              <p>{t('about.about_paragraph_3')}</p>
              <div className='flex justify-center lg:justify-start'>
                <Link to='/about'>
                  <Button className='w-48'>{t('buttons.about_button')}</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
